import { validateNaturalDocument } from './validateNaturalDocument';
import { validateLegalDocument } from './validateLegalDocument';
import { isLegalDocumentLike, normalizeStoredDocument } from './document';

export function validateDocument(document: string): boolean {
  const normalizedDocument = normalizeStoredDocument(document);

  if (isLegalDocumentLike(document)) {
    return validateLegalDocument(normalizedDocument);
  }

  return validateNaturalDocument(normalizedDocument);
}
